import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AppTitleComponent } from '../core/components/app-title/app-title.component';
import { InstallPwaComponent } from '../toExtract/pwa/installer/install-pwa.component';

@Component({
  selector: 'pd-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AppTitleComponent,
    InstallPwaComponent,
    NgClass,
    MatButtonModule,
    RouterLink,
    RouterOutlet,
  ],
})
export class LandingComponent {}
